export default "__VITE_ASSET__BWeR6GD8__"